import { SvgIcon, SvgIconProps } from "@mui/material";

export const HelenaAgentIcon = (props: SvgIconProps) => {
  const fill = props.fill || "#6727F4";

  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="6.00098" cy="8" r="1" fill={fill} />
        <circle cx="10.001" cy="8" r="1" fill={fill} />
        <path
          d="M13.4658 2C13.6431 2 13.7214 2.22326 13.583 2.33398L12.042 3.56543C13.2452 4.6627 14 6.2433 14 8C14 11.3137 11.3137 14 8 14H2.53516C2.35792 14 2.27957 13.7767 2.41797 13.666L3.95703 12.4336C2.75447 11.3363 2 9.7562 2 8C2.00007 4.68635 4.68633 2 8 2H13.4658ZM8 3.2002C5.34907 3.2002 3.20026 5.34909 3.2002 8C3.2002 10.651 5.34903 12.7998 8 12.7998C10.651 12.7998 12.7998 10.651 12.7998 8C12.7997 5.34909 10.6509 3.2002 8 3.2002Z"
          fill={fill}
        />
      </svg>
    </SvgIcon>
  );
};
